var $563819b0f60f7662$exports = {};
$563819b0f60f7662$exports = {
    "endTime": `Endzeit`,
    "startTime": `Startzeit`,
    "time": `Uhrzeit`
};


export {$563819b0f60f7662$exports as default};
//# sourceMappingURL=de-DE.mjs.map
